import React from "react";
import AdminSidebar from "../components/AdminSidebar";
import ProfileHeader from "../components/ProfileHeader";
import GenerateAnalytics from "../components/GenerateAnalytics";

const GenerateAnalyticsPage = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <AdminSidebar />

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <ProfileHeader />
        <GenerateAnalytics />
      </div>
    </div>
  );
};

export default GenerateAnalyticsPage;
